export default [
  {
    path: '*',
    meta: {
      public: true
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/404',
    meta: {
      public: true
    },
    name: 'NotFound',
    component: () => import(`@/pages/notfound.vue`)
  },
  {
    path: '/403',
    meta: {
      public: true
    },
    name: 'AccessDenied',
    component: () => import(`@/pages/deny.vue`)
  },
  {
    path: '/500',
    meta: {
      public: true
    },
    name: 'ServerError',
    component: () => import(`@/pages/error.vue`)
  },
  {
    path: '/login',
    meta: {
      public: true
    },
    name: 'Login',
    component: () => import(`@/pages/login.vue`)
  },
  {
    path: '/',
    meta: {},
    name: 'Root',
    redirect: {
      name: 'Search'
    }
  },
  {
    path: '/search',
    meta: { breadcrumb: true },
    name: 'Search',
    component: () => import(`@/pages/search/index.vue`)
  },
  {
    path: '/dispatch',
    meta: { breadcrumb: true },
    name: 'Dispatch',
    component: () => import(`@/pages/dispatch/Index.vue`)
  },
  {
    path: '/dispatch/overview',
    meta: { breadcrumb: true },
    name: 'Overview',
    component: () => import(`@/pages/dispatch/Overview.vue`)
  },
  {
    path: '/monitor',
    meta: { breadcrumb: true },
    name: 'Monitor',
    component: () => import(`@/pages/monitor/Index.vue`)
  },
  {
    path: '/reporting/detail',
    meta: { breadcrumb: true },
    name: 'DetailReporting',
    component: () => import(`@/pages/reporting/Detail.vue`)
  },
  {
    path: '/reporting/worktime',
    meta: { breadcrumb: true },
    name: 'WorkTimeReporting',
    component: () => import(`@/pages/reporting/WorkTime.vue`)
  },
  {
    path: '/sendsms',
    meta: { breadcrumb: true },
    name: 'sendsms',
    component: () => import(`@/pages/sendsms/Index.vue`)
  },
  {
    path: '/sendnotify',
    meta: { breadcrumb: true },
    name: 'sendnotify',
    component: () => import(`@/pages/SendNotify.vue`)
  },
  {
    path: '/historylog',
    meta: { breadcrumb: true },
    name: 'historylog',
    component: () => import(`@/pages/HistoryLogs.vue`)
  },
  {
    path: '/supporter',
    meta: { breadcrumb: true },
    name: 'supporter',
    component: () => import(`@/pages/Supporter.vue`)
  }
];



// WEBPACK FOOTER //
// ./src/router/paths.js